import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=76a7f590&scoped=true&lang=pug&"
import script from "./ConfigList.vue?vue&type=script&lang=ts&"
export * from "./ConfigList.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=76a7f590&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7f590",
  null
  
)

export default component.exports